import { useAuth } from "./AuthProvider";

type Props = {
  email: String;
};

export const EmailVerifyWidget = (props: Props) => {
  const auth = useAuth();

  return (
    <div className="email-verify-widget">
      <div className="form-header">
        <div className="heading">Email Verification</div>
        <div className="sub-heading">
          Please click on the verification link sent to <span className="mail">{props.email}</span> to complete the
          signup process.
        </div>
      </div>
      <div className="form-actions">
        <button
          className="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          It's done!
        </button>
        <button
          className="card-button"
          onClick={() => {
            auth.logout();
          }}
        >
          Logout
        </button>
        <div className="resend-email-message">
          No email in your inbox or spam folder?&nbsp;
          <span onClick={() => {}}>
            <a href="#">Resend Email</a>
          </span>
        </div>
      </div>
    </div>
  );
};
